/* External */
import { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import { joinClassNames } from '@dtvgo/classnames';
import { getDisplayName } from './utils';

export function withClassName(className) {
  return (WrappedComponent) => {
    const WithClassName = forwardRef(({ className: internal, ...props }, ref) => (
      <WrappedComponent className={joinClassNames(className, internal)} {...props} ref={ref} />
    ));

    WithClassName.propTypes = {
      className: PropTypes.string,
    };

    WithClassName.defaultProps = {
      className: undefined,
    };

    WithClassName.displayName = `WithClassName(${getDisplayName(WrappedComponent)})`;

    return memo(WithClassName);
  };
}
